import { Router } from '../router/Router';
import { ApiService } from './ApiService';

/**
 * Handle the Session Service Error.
 */
export class SessionService {
  /**
   * The Session template in order to handle session error and display it.
   *
   * @type {string}
   */
  static template;

  /**
   * The timer of the application.
   *
   * @type {object}
   */
  static timer;

  /**
   * The duration of the session.
   */
  static duration;

  /**
   * Init configuration for the session service.
   *
   * @param   {object} opts - The object parameter containing the settings for the session.
   */
  static initConfig(opts) {
    SessionService.template = opts && opts.template;
    SessionService.duration = opts && opts.duration * 1000;
  }

  /**
   * Create the session timer for the application.
   */
  static createSessionTimer() {
    if (SessionService.template && SessionService.duration) {
      SessionService.timer = setTimeout(() => {
        if (!ApiService.requestPending) {
          Router.insertExpire();
        }
      }, SessionService.duration);
    }
  }

  /**
   * Clear the session timer for the application.
   */
  static resetSessionTimer() {
    if (SessionService.timer) {
      clearTimeout(SessionService.timer);
    }
  }

  /**
   * Restart the session timer for the application.
   */
  static restartSessionTimer() {
    SessionService.resetSessionTimer();
    SessionService.createSessionTimer();
  }
}
